import {
  isDemandGroup,
  isLineOfBusiness,
  isSupplyGroup,
} from "src/util/customerConfig";
import { pickPlanningAccessConfig } from "src/allocation/util/planningAccess";
import { FORECAST, PLANNER } from "../pageModes";
import {
  computeSubmitKey,
  isSubmittedForCurrentPeriod,
} from "../util/submitKeyUtil";

export const buildRootGroup = (
  group,
  groupTypes,
  forecastRootGroupProps,
  allocation
) => {
  return {
    ...group,
    isSource: isSupplyGroup(groupTypes, group),
    isDemand: isDemandGroup(groupTypes, group),
    isLineOfBusiness: isLineOfBusiness(groupTypes, group),
    allocationConfig: pickPlanningAccessConfig(allocation),
    ...forecastRootGroupProps,
  };
};

export const getPageProps = (
  allocation,
  pageMode,
  group,
  activeAllocationProject
) => {
  const {
    enableFinancialForecasting,
    financialYear,
    overBudgetLimit,
    underBudgetLimit,
    enableForecastSubmitting,
    enablePlannerBudgetTarget,
    useDeltaForBudget,
    plannerOverBudgetLimitPercentage,
    plannerUnderBudgetLimitPercentage,
    enableMemberFteEdit,
    desiredInputAsDelta,
    showMacroAllocationInput,
  } = allocation;

  let pageProps = {};
  let forecastRootGroupProps = {};

  if (pageMode === PLANNER) {
    pageProps = {
      isBudgetEnabled: enablePlannerBudgetTarget,
      useDeltaForBudget,
      overBudgetLimit: plannerOverBudgetLimitPercentage,
      underBudgetLimit: plannerUnderBudgetLimitPercentage,
      isRealtimeFteMode: enableMemberFteEdit,
      useRealtimeChangeOnly: enableMemberFteEdit && !showMacroAllocationInput,
      useRealtimeFteDelta: enableMemberFteEdit && desiredInputAsDelta,
    };
  } else if (pageMode === FORECAST) {
    pageProps = {
      isBudgetEnabled: enableFinancialForecasting,
      overBudgetLimit,
      underBudgetLimit,
    };

    const submitKey = computeSubmitKey(activeAllocationProject, financialYear);
    const isSubmitted = isSubmittedForCurrentPeriod(
      group.forecastSubmittedFor,
      submitKey,
      financialYear
    );

    forecastRootGroupProps = {
      enableForecastSubmitting,
      forecastSubmittedAt: isSubmitted ? group.forecastSubmittedAt : 0,
    };
  }

  return [pageProps, forecastRootGroupProps];
};
